const INTERVAL_TO_SECONDS = {
  sec: 1,
  min: 60,
  hour: 3600
}

const INTERVAL_TO_HUMAN = {
  sec: "Second",
  min: "Minute",
  hour: "Hour"
}

export const humanInterval = (period, interval) => {
  if (period && interval) {
    const hInterval = INTERVAL_TO_HUMAN[interval]
    if (hInterval) {
      return period > 1 ? hInterval + "s" : hInterval
    } else {
      return interval
    }
  } else {
    return interval
  }
}

export const periodIntervalToSeconds = (period, interval) =>
  Math.round(period * INTERVAL_TO_SECONDS[interval])
